import { reportWorkerError } from '$$workerErrorReporting';

function sourceFromPath(path) {
  const match = path.match(/\/([^/]+)\.js/);

  return match ? match[1] : 'worker';
}

export default function (workerPath) {
  const worker = new Worker(workerPath);
  const source = sourceFromPath(workerPath);

  return function (workerData) {
    return new Promise((resolve, reject) => {
      worker.onmessage = function (e) {
        worker.onmessage = null;
        worker.onerror = null;

        return resolve(e.data);
      };

      worker.onerror = function (e) {
        worker.onmessage = null;
        worker.onerror = null;
        reportWorkerError(e, source);
        const message = e.message || `${e.filename || 'worker'}:${e.lineno || 0}`;
        const err = new Error(message);
        const filename = e.filename || 'worker';
        const lineno = e.lineno || 0;
        const colno = e.colno != null ? e.colno : 0;
        err.stack = `Error: ${message}\n    at onmessage (${filename}:${lineno}:${colno})`;
        reject(err);
      };

      worker.postMessage(workerData);
    });
  };
}
